import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CategoryInterface } from "../../../interfaces/categoryInterface";
import { ApiResponse } from "../../../interfaces/apiResponseInterface";
import { categoryApi } from "../services/category.api";
import {
  errorNotification,
  successNotification,
} from "../../../utils/notification";
import {
  CATEGORY_MESSAGES_ERROR,
  CATEGORY_MESSAGES_SUCCESS,
} from "../constants/messages";

export const useSaveCategoryMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<ApiResponse<CategoryInterface>, Error, CategoryInterface>({
    mutationFn: (category) => categoryApi.saveCategory(category),
    onSuccess: (res, variables) => {
      if (!res.ok) {
        errorNotification(CATEGORY_MESSAGES_ERROR.SAVE_ERROR);
        return;
      }
      successNotification(CATEGORY_MESSAGES_SUCCESS.SAVE_SUCCESS);
      queryClient.invalidateQueries({ queryKey: ["categories-filter"] });
      queryClient.invalidateQueries({ queryKey: ["categories"] });
      if (variables._id) {
        queryClient.invalidateQueries({
          queryKey: ["category-by-id", variables._id],
        });
      }
    },
    onError: () => {
      errorNotification(CATEGORY_MESSAGES_ERROR.SAVE_ERROR);
    },
  });
};
